export enum Role {
  CUSTOMER = "customer",
  THERAPIST = "therapist",
}
